import { render } from "./QtlInfoModal.vue?vue&type=template&id=b3d0a0cc&scoped=true"
import script from "./QtlInfoModal.js?vue&type=script&lang=js"
export * from "./QtlInfoModal.js?vue&type=script&lang=js"

import "./QtlInfoModal.vue?vue&type=style&index=0&id=b3d0a0cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d0a0cc"]])

export default __exports__